import React from 'react';

const HomeFiveSingleMedicalTab = () => {
   return (
      <>
         <div className="row">
            <div className="col-lg-6">
               <div className="h5medical__thumb mb-30">
                  <img src="img/home5/tab/tab.jpg" alt="" />
               </div>
            </div>
            <div className="col-lg-6">
               <div className="h5medical-content mb-30">
                  <h4 className="f-600 theme-color">We Care Our Patient Very Carefully & Your Patient Happy With Us</h4>
                  <p>Must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure,</p>
                  <ul>
                     <li><i className="far fa-arrow-alt-circle-right"></i>The Best Medical Care In The Worlds</li>
                     <li><i className="far fa-arrow-alt-circle-right"></i>Embarking On New Adventures Inspiring Desktop</li>
                     <li><i className="far fa-arrow-alt-circle-right"></i>Local Development For Beginners Setup</li>
                  </ul>
               </div>
            </div>
         </div>
      </>
   );
};

export default HomeFiveSingleMedicalTab;